import { appSetLoading, appSetSendingRequest } from "store/actions/appAction";
import { setAction, setEditItem } from "store/actions/formAction";
import { resetForm, setIndex, updateFormStatus } from "../store/actions/formAction";
import { setPosFormData } from "../helpers/FormDataCreator";
import { errorDispatcher } from "../helpers";
import { apiSetAlert } from "./appApi";
import axios from "../axios/axios";


export const apiGetPos = (token, callback, id) => (dispatch) => {
    let url = `pos/list?financialType=bank`
    // dispatch(appSetLoading());
    axios.get(url, {
        headers: { Authorization: `Bearer ${token}` }
    })
        .then((response) => {
            // dispatch(appSetLoading(false));
            if (callback) {
                callback(response)
            }
        })
        .catch((error) => {

        })
}
export const apiGeFunctiontPos = (id, token) => (dispatch, getState) => {
    dispatch(appSetLoading());
    axios
        .get(`pos/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
            dispatch(setEditItem(response.data.pos));
            dispatch(appSetLoading(false));
        })
        .catch((error) => {
            errorDispatcher(error, dispatch);
        });
};
export const apiAddPos = (dispatch, forms, token, index, navigate, modalProps, errorIndex = null) => {
    const form = forms[index];

    const nextApi = (res) => {
        if (index + 1 < forms.length) {
            apiAddFinancial(dispatch, forms, token, index + 1, navigate, modalProps, errorIndex);
        } else {
            dispatch(appSetSendingRequest(false));
            if (errorIndex !== null) {
                dispatch(setAction("filling"));
                dispatch(apiSetAlert(forms[errorIndex].errors, "error"));
                dispatch(setIndex(forms[errorIndex].index));
            } else {
                //dispatch(apiSetAlert("حسابهای شما با موفقیت ثبت شدند", "success", !!modalProps));
                dispatch(resetForm());
                if (modalProps) {
                    dispatch(appCloseModal());
                    dispatch(resetForm());
                    if (res) {
                        modalProps.onFinish(token, res);
                    } else {
                        dispatch(modalProps.onFinish(token));
                    }
                } else {
                    const type = forms[forms.length - 1].others.formType;
                    navigate("/financials", {
                        state: { type }
                    });
                }
            }
        }
    };

    if (form.status !== "saved") {
        dispatch(setIndex(form.index));
        dispatch(updateFormStatus("saving"));
        const formData = setPosFormData(form);
        axios
            .post("/pos", formData, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then((response) => {
                dispatch(updateFormStatus("saved"));
                nextApi(response.data?.financial);
            })
            .catch((error) => {
                errorIndex = index;
                dispatch(updateFormStatus("error", error?.response?.data?.message));
                nextApi();
            });
    } else {
        nextApi();
    }
};
export const apiAddPosAction = (forms, token, navigate, modalProps) => (dispatch, getState) => {
    dispatch(appSetSendingRequest(true));
    dispatch(setAction("save"));
    apiAddPos(dispatch, forms, token, 0, navigate, modalProps);
};

export const apiUpdatePos = (posId, form, token, navigate) => (dispatch, getState) => {
    const formData = setPosFormData(form);

    dispatch(appSetSendingRequest(true));
    axios
        .put(`pos/${posId}`, formData, {
            headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
            dispatch(apiSetAlert(response.data.message, "success", true));
            navigate("/financials", {
                state: { type: "posSetting" }
            });
        })
        .catch((error) => {
            errorDispatcher(error, dispatch);
        });
};
export const apiDeletePos = (branchId, token, callback) => (dispatch, getState) => {
    dispatch(appSetLoading());
    axios
        .delete(`/pos/${branchId}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
            dispatch(apiSetAlert(response.data.message, "success"));

            callback(response)
        })
        .catch((error) => {
            errorDispatcher(error, dispatch);
        });
};

